import type { Time } from '@morpho-org/morpho-ts'
import type { Hex } from 'viem'

import type { HistoryRange } from '@/lib/transforms/history/window'

import { orpc } from '@/lib/orpc/client'

export const DEFAULT_MARKET_APY_HISTORY_TIMEFRAME: Time.PeriodLike = 'mo'

/** Above 0 so a history prefetched on the server is not refetched as soon as it hydrates. */
const MARKET_APY_HISTORY_STALE_TIME_MS = 60_000

export const marketApyHistoryQueryOptions = (input: {
  chainId: number
  marketId: Hex
  range: HistoryRange
}) => orpc.market.apyHistory.queryOptions({ input, staleTime: MARKET_APY_HISTORY_STALE_TIME_MS })
